<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16FjzI0/tc-custom/9781526771940.jpg?1733093596413" alt="This image is the cover for the book Ace of the Black Cross"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ace of the Black Cross
      </h1>
      <p class="bookDescription body article font2">
        <p>Above the mud and misery of the trenches and the endless slugging matches of the First World War another contest was played out with all the military glamor, chivalric values and deadly outcome of a medieval, knightly tournament. This was the battle in the air between the first primitive aircraft and the intrepid aviators who flew them. This image of air war is brought nobly to light in the memoirs of Ernst Udet, the German ace of aces, whose impressive wartime record was second only to the legendary Red Baron.   Written in a jaunty, Boys Own style, Udet paints a romantic picture of his experiences and captures what perhaps many young pilots must have felt as they flew off each day to duel with the enemy, the elements and an unreliable technology. Ace of the Black Cross also illustrates the way in which war and defeat left this young generation of tough, spirited, individuals rootless and restless. After the war Udet used his flying skills to give displays to crowds of gawking onlookers, a circus act that left him frustrated and resentful. In 1941, disillusioned and depressed, he shot himself. On the wall before he died he scrawled a message for Goring: Iron man, you have betrayed me.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ernst Udet, Richard Overy
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Frontline Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?56909d47